/* eslint-disable no-param-reassign */
import axios from 'axios';
import config from './config';
import { getLocalStorage } from '../utils/utils';

export function getToken() {
  const loginInfo = JSON.parse(localStorage.getItem('user'));
  if (loginInfo) {
    return loginInfo.token;
  }
  return null;
}

const instance = axios.create({
  baseURL: config.backendBaseUrl,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': getLocalStorage('lang'),
    'Session-Id': getLocalStorage('sessionId'),
  },
});

// 添加请求拦截器
instance.interceptors.request.use(
  (axiosConfig) => {
    if (axiosConfig.url.indexOf('postFormUrl/') !== -1) {
      let newData = '';
      axiosConfig.url = axiosConfig.url.split('postFormUrl/')[1];
      axiosConfig.headers['Content-type'] = 'application/x-www-form-urlencoded';
      for (let index = 0; index < axiosConfig.data.length; index += 1) {
        newData += `${encodeURIComponent(axiosConfig.data[index].name)}=${encodeURIComponent(axiosConfig.data[index].value)}&`;
      }
      axiosConfig.data = newData;
    } else {
      axiosConfig.headers['Content-type'] = 'application/json';
    }
    axiosConfig.headers['Accept-Language'] = getLocalStorage('lang');
    axiosConfig.headers['Session-Id'] = getLocalStorage('sessionId');
    return axiosConfig;
  },
  // 对请求错误做些什么
  error => Promise.reject(error),
);

// 添加响应拦截器
instance.interceptors.response.use(
  // 对响应数据做点什么
  response => response.data,
  // 对响应错误做点什么
  (error) => {
    let errorMsg = null;
    if (error.response) {
      errorMsg = `网络异常[${error.response.status}]`;
    } else if (error.request) {
      // 超时
      if (error.request.readyState === 4 && error.request.status === 0) {
        errorMsg = '请求超时';
      } else {
        errorMsg = '请求失败';
      }
    }
    return {
      code: 1,
      msg: errorMsg,
    };
  },
);

export default instance;



// WEBPACK FOOTER //
// ./src/lib/axiosUtils.js